import React from 'react';
import { Immutable, toImmutable } from 'nuclear-js';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';

import { seasonNames } from 'resources/common-values';
import CommonStrings from 'resources/common-strings';

import TermUtils from 'utils/terms';
import GrowthGoalsUtils from './utils';

export default CreateReactClass({
    displayName: 'PastGoals',

    propTypes: {
        pastGrowthGoal: PropTypes.instanceOf(Immutable.Map),
        goalStatus: PropTypes.object,
    },

    renderNoGoals() {
        return <p className="past-goal-bottom-line">{CommonStrings.noPreviousGoalsForStudent}</p>;
    },

    renderNotTested(endTerm, goalStatus) {
        return (
            <div key="endTerm" className="past-goal-bottom-line growth-goal-module-info not-tested-display">
                <p className="term-name term-name-past-goal-margin">{endTerm} GOAL</p>
                <p className={goalStatus.className}>{goalStatus.description}</p>
            </div>
        );
    },

    renderPerformanceGoal(endTerm, goalStatus, goal) {
        const typicalScore = goal.get('typicalScore')
            ? goal.get('typicalScore')
            : `${CommonStrings.nbsp}+${CommonStrings.blanks}`;

        return (
            <div key="endTerm" className="growth-goal-wrapper past-goal-bottom-line">
                <div className="growth-goal-module-info">
                    <p className="term-name term-name-past-goal-margin">{endTerm} GOAL</p>
                    <span className={goalStatus.className}>{goalStatus.description}</span>
                </div>
                <div className="score-label">
                    <p className=" score-actual">Actual:</p>
                    <p>Goal:</p>
                    <p>Typical Score:</p>
                </div>
                <div className="growth-goal-score">
                    <p className="score-actual">{goal.get('endTermScore')}</p>
                    <p>{goal.get('targetScore')}</p>
                    <p>{typicalScore}</p>
                </div>
            </div>
        );
    },

    renderGrowthGoals(endTerm, startTerm, goalStatus, goal) {
        return (
            <div key={endTerm} className="growth-goal-wrapper past-goal-bottom-line">
                <div className="growth-goal-module-info">
                    <p className="term-name term-name-past-goal-margin">{endTerm} GOAL</p>
                    <span className={goalStatus.className}>{goalStatus.description}</span>
                </div>
                <div className="score-label">
                    <p className=" score-actual">Actual:</p>
                    <p>Goal:</p>
                    <p>Score when set:</p>
                    <p className="growth-set-term">({startTerm})</p>
                </div>
                <div className="growth-goal-score">
                    <p className="score-actual">{goal.get('endTermScore')}</p>
                    <p>{goal.get('targetScore')}</p>
                    <p>{goal.get('startTermScore')}</p>
                </div>
            </div>
        );
    },

    render() {
        if (this.props.pastGrowthGoal) {
            const goal = this.props.pastGrowthGoal;
            const endTerm = TermUtils.textFromTermNumber(goal.get('endTermNumber'), true);

            if (this.props.goalStatus.testedYn) {
                if (GrowthGoalsUtils.isGrowthGoal(goal)) {
                    const startTerm = TermUtils.textFromTermNumber(goal.get('startTermNumber'), true);
                    return this.renderGrowthGoals(endTerm, startTerm, this.props.goalStatus, goal);
                } else {
                    return this.renderPerformanceGoal(endTerm, this.props.goalStatus, goal);
                }
            } else {
                return this.renderNotTested(endTerm, this.props.goalStatus);
            }
        }

        return this.renderNoGoals();
    },
});
